// extracted by extract-css-chunks-webpack-plugin
module.exports = {"close-drawer":"bottomDrawer__close-drawer","btn-div":"bottomDrawer__btn-div","close_bar":"bottomDrawer__close_bar","content-div":"bottomDrawer__content-div"};